import {bindEvent} from '../helpers/message_ifame';
import {checkIsAdmin, hash} from '../helpers/utils';
import {trackViews, trackClicks} from './widget-report';
import storage from './storage';
import {MESSAGE_WIDGET_TRACK_VIEW, MESSAGE_WIDGET_TRACK_CLICK, MESSAGE_WIDGET_MARK_ID} from './constant';

class WidgetTracking {
  constructor() {
    this.keyTrackViewed = 'ar[wgktv;;' + hash(document.domain);
    this.session = JSON.parse(storage.getStorage(this.keyTrackViewed)) || [];
    this.listWidgetLoaded = [];
  }

  init() {
    if (checkIsAdmin() === true) return;

    bindEvent(window, 'message', (event) => {
      if (!event.data.hasOwnProperty('message')) return;

      if (event.data.message === MESSAGE_WIDGET_TRACK_VIEW) {
        const {shopId, widgetId} = event.data.data;
        trackViews(shopId, [widgetId]);
      }

      if (event.data.message === MESSAGE_WIDGET_TRACK_CLICK) {
        const {shopId, widgetId, productId} = event.data.data;
        trackClicks(shopId, widgetId, productId);
      }

      if (event.data.message === MESSAGE_WIDGET_MARK_ID) {
        const {widgetId} = event.data.data;
        this.listWidgetLoaded.push(widgetId);
      }
    });

    window.addEventListener('scroll', () => {
      let listWidgetBoxs = document.querySelectorAll('[data-section-type="widget-box"]');
      let listWidgetCarousels = document.querySelectorAll('[data-section-type="widget-carousel"]');

      if (listWidgetBoxs) {
        listWidgetBoxs.forEach(widgetBox => {
          this.track(widgetBox);
        });
      }

      if (listWidgetCarousels) {
        listWidgetCarousels.forEach(carousel => {
          this.track(carousel);
        });
      }
    });
  }

  track(target) {
    let iframe = target.querySelector('iframe.aliReviewsFrame[widget-id]');
    if (!iframe) return;
    if (!iframe.src || 0 === iframe.src.length) return;
    let widgetId = iframe.getAttribute('widget-id');
    if (!this.listWidgetLoaded.includes(widgetId)) return;
    if (this.session.includes(widgetId) && this.session.includes(this.pageType)) return;
    if (iframe.getBoundingClientRect().top > window.innerHeight) return;
    let shopId = new URL(iframe.src).searchParams.get('shop_id');
    trackViews(shopId, [widgetId]);
    [widgetId, this.pageType].forEach(val => {
      if (this.session.indexOf(val) === -1) {
        this.session.push(val);
      }
    });
    storage.setStorage(this.keyTrackViewed, JSON.stringify(this.session));
  }
}

new WidgetTracking().init();
